import {
  GET_SERVICES,
  GET_SERVICES_SUCCESS,
  GET_SERVICES_FAILURE,
  UPDATE_SERVICE_STATUS,
  UPDATE_SERVICE_STATUS_SUCCESS,
  UPDATE_SERVICE_STATUS_FAILURE,
  DELETE_SERVICE,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAILURE,
  ADD_SERVICE,
  ADD_SERVICE_SUCCESS,
  ADD_SERVICE_FAILURE,
  EDIT_SERVICE,
  EDIT_SERVICE_SUCCESS,
  EDIT_SERVICE_FAILURE,
  SERVICE_DETAILS,
  SERVICE_DETAILS_SUCCESS,
  SERVICE_DETAILS_FAILURE,
  QUESTION_DROPDOWN_LIST,
  QUESTION_DROPDOWN_LIST_SUCCESS,
  QUESTION_DROPDOWN_LIST_FAILURE,
  UPDATE_SERVICES_ORDER_STATUS,
  UPDATE_SERVICES_ORDER_STATUS_SUCCESS,
  UPDATE_SERVICES_ORDER_STATUS_FAILURE,
  RESET_ADD_SERVICE_DATA,
} from "../Constants";

const init = {
  data: {},
  delete_data: {},
  edit_data: {},
  add_data: {},
  update_data: {},
};

const ServicesReducer = (state = init, action) => {
  switch (action.type) {
    case GET_SERVICES:
      return { ...state, loading: true };
    case GET_SERVICES_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case GET_SERVICES_FAILURE:
      return { ...state, loading: false, data: action.payload };
    case DELETE_SERVICE:
      return { ...state, loading: true };
    case DELETE_SERVICE_SUCCESS:
      return { ...state, loading: false, delete_data: action.payload };
    case DELETE_SERVICE_FAILURE:
      return { ...state, loading: false, delete_data: action.payload };
    case UPDATE_SERVICE_STATUS:
      return { ...state, loading: true };
    case UPDATE_SERVICE_STATUS_SUCCESS:
      return { ...state, loading: false, update_data: action.payload };
    case UPDATE_SERVICE_STATUS_FAILURE:
      return { ...state, loading: false, update_data: action.payload };
    case ADD_SERVICE:
      return { ...state, loading: true };
    case ADD_SERVICE_SUCCESS:
      return { ...state, loading: false, add_data: action.payload };
    case ADD_SERVICE_FAILURE:
      return { ...state, loading: false, add_data: action.payload };
    case EDIT_SERVICE:
      return { ...state, loading: true };
    case EDIT_SERVICE_SUCCESS:
      return { ...state, loading: false, edit_data: action.payload };
    case EDIT_SERVICE_FAILURE:
      return { ...state, loading: false, edit_data: action.payload };
    case SERVICE_DETAILS:
      return { ...state, loading: true };
    case SERVICE_DETAILS_SUCCESS:
      return { ...state, loading: false, details_data: action.payload };
    case SERVICE_DETAILS_FAILURE:
      return { ...state, loading: false, details_data: action.payload };
    case QUESTION_DROPDOWN_LIST:
      return { ...state, loading: true };
    case QUESTION_DROPDOWN_LIST_SUCCESS:
      return { ...state, loading: false, question_data: action.payload };
    case QUESTION_DROPDOWN_LIST_FAILURE:
      return { ...state, loading: false, question_data: action.payload };
    case UPDATE_SERVICES_ORDER_STATUS:
      return { ...state, loading: true };
    case UPDATE_SERVICES_ORDER_STATUS_SUCCESS:
      return { ...state, loading: false, order_data: action.payload };
    case UPDATE_SERVICES_ORDER_STATUS_FAILURE:
      return { ...state, loading: false, order_data: action.payload };
    case RESET_ADD_SERVICE_DATA:
      return { ...state, loading: true, add_data: init };
    default:
      return state;
  }
};

export default ServicesReducer;
